
/**
 * IE対応関連のユーティリティ
 * */
export module relic {

	/**
	 * list.find()の代替え関数
	 * @param list		：走査対象のリスト
	 * @param chkFunc	：比較関数
	 * @param dupli		：複製を返す場合はtrue
	 */
    export function listFind(list: any[], chkFunc: (item: any) => boolean, dupli: boolean = false): any {
		for (let i: number = 0; i < list.length; i++) {
			if (chkFunc(list[i])) {
				var res = list[i];
				if (dupli) res = JSON.parse(JSON.stringify(res));
				return res;
			}
		}
		return undefined;
	}



}